import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TokenTransactions from './TokenTransactions'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';

class Token extends PureComponent {
  render() {
    const { classes } = this.props;
    const token = this.props.match.params.token;
    const campaignPrefix = this.props.match.params.campaignPrefix;

    return (
      <Grid container spacing={24}>
        <Grid item xs={12}>
          <Typography variant='display2'>Token: {token}</Typography>
          <Typography variant='display1'>Group: {campaignPrefix}</Typography>
        </Grid>
        <Grid item xs={12}>
            <TokenTransactions token={token} campaignPrefix={campaignPrefix}/>
        </Grid>
      </Grid>
    );
  }
}


const styles = theme => ({

});

export default withStyles(styles)(Token);


// WEBPACK FOOTER //
// ./src/components/Token.js